import { useNavigate } from 'react-router-dom';
import { Menu, useTheme } from '@mui/material';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Typography,
  CircularProgress,
  Link,
} from '@mui/material';
import { useGetChangelog } from '../hooks/reactQuerys/ChangelogQueries';

type IProps = {
  open: boolean;
  onClose: () => void;
  anchorEl: HTMLElement | null;
};

export const ChangelogMenu = ({ open, onClose, anchorEl }: IProps) => {
  const { changelog, isLoadingChangelog } = useGetChangelog();
  const navigate = useNavigate();
  const theme = useTheme();

  const sortedChangelog =
    changelog?.releases.sort(
      (a, b) =>
        new Date(b.releaseAt).getTime() - new Date(a.releaseAt).getTime()
    ) ?? [];

  if (isLoadingChangelog) {
    return <CircularProgress />;
  }

  if (!changelog) {
    return <Typography>Keine Changelogs gefunden</Typography>;
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <Box sx={{ maxWidth: 500, maxHeight: 300, overflow: 'auto', p: 2 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 4,
          }}
        >
          <Typography variant='h6'>Changelog</Typography>
          <Link
            onClick={() => {
              navigate('/changelog');
              onClose();
            }}
            sx={{ cursor: 'pointer' }}
          >
            Alle Neuerungen anzeigen
          </Link>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: 2,
            mt: 2,
          }}
        >
          {sortedChangelog.map(release => (
            <Card
              key={release.id}
              variant='outlined'
              onClick={() => {
                navigate('/changelog');
                setTimeout(() => {
                  document
                    .getElementById(`release-${release.id}`)
                    ?.scrollIntoView({ behavior: 'smooth' });
                }, 100);

                onClose();
              }}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant='h6'>{release.title}</Typography>
                  <Chip
                    label={new Date(release.releaseAt).toLocaleDateString()}
                    size='small'
                  />
                </Box>
                <div
                  dangerouslySetInnerHTML={{ __html: release.descriptionHtml }}
                />
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    </Menu>
  );
};
